
import configureStore, { history } from './configureStore';

export { history };

export const store = configureStore({});
